import { useState, useEffect } from "react";
import Button from "../../../../../components/Button";
import DialogComponent from "../../../../../components/DialogComponent";

type Props = {
    open: boolean;
    toggleDialog: (b: boolean) => void;
    setOpen: (b: boolean) => void;
    setCloseAllModals: (b: boolean) => void;
    closeAllModals: boolean;
}

function CancelAddCard(props: Props) {

    const { open, toggleDialog, setOpen, setCloseAllModals, closeAllModals } = props;

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="cancelAddCard">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Подтвердите действие</span>
                <span className="block text-[16px] leading-[22px] mb-[38px]">Вы&nbsp;уверены, что хотите закрыть окно?<br />Вся введенная вами информация будет сброшена.<br />Заполните все поля, чтобы сохранить документ.</span>
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Закрыть без сохранения"
                            setCloseAllModals={setCloseAllModals}
                            closeAllModals={closeAllModals}
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text="Вернуться к документу"
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
}

export default CancelAddCard;



